module.exports = {"TXTMOB_No_results":{"id":"TXTMOB_No_results","defaultMessage":"Aucun résultat"}}